// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import * as moment from 'moment-timezone';
import { plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
// Constants
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';
// Model imports
import { PlattedLotResultDto } from '../_models/platted-lot-result-dto';
import { ConveyanceResultDto } from '../_models/conveyance-result-dto';
import { UserDashboardResultDto } from '../_models/user-dashboard-result-dto';
import { UserDashboardProxyListResultDto } from '../_models/user-dashboard-proxy-list-result-dto';
import { UserDashboardByCommunityResultDto } from '../_models/user-dashboard-by-community-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class SharedWidgetsService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    getPlattedLot(communityId = null, clearCache = true) {
        const tokens = [`clearCache=${clearCache}`];
        if (!!communityId) {
            tokens.push(`communityId=${communityId}`);
        }
        const url = `${URLConstants.ccCommunityApiBaseUrl}dashboard/plattedlot?${tokens.join('&')}`;
        this.cacheRegistrationService.registerForCache(url, clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(PlattedLotResultDto, responseData)));
    }
    getConveyanceActivity(communityId = null, periodEnding = new Date(), clearCache = true) {
        const tokens = [`clearCache=${clearCache}`, `periodEnding=${moment(periodEnding).format('YYYY-MM-DD')}`];
        if (!!communityId) {
            tokens.push(`communityId=${communityId}`);
        }
        const url = `${URLConstants.ccCommunityApiBaseUrl}dashboard/conveyance?${tokens.join('&')}`;
        this.cacheRegistrationService.registerForCache(url, clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(ConveyanceResultDto, responseData)));
    }
    getUserDashboardUsers(clearCache = false) {
        const url = `${URLConstants.ccUserBaseApiUrl}/dashboard/users?clearCache=${clearCache}`;
        this.cacheRegistrationService.registerForCache(url, clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(UserDashboardProxyListResultDto, responseData)));
    }
    getUserDashboard(params) {
        const url = `${URLConstants.ccUserBaseApiUrl}/dashboard?${params.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, params.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(UserDashboardResultDto, responseData)));
    }
    getUserDashboardByCommunity(params) {
        const url = `${URLConstants.ccUserBaseApiUrl}/dashboard/workarea?${params.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, params.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(UserDashboardByCommunityResultDto, responseData)));
    }
}
SharedWidgetsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SharedWidgetsService_Factory() { return new SharedWidgetsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: SharedWidgetsService, providedIn: "root" });
